import { PLATFORM_PRODUCT_FEE } from "../constants";

export const parseProduct = (product) => ({
  ...product,
  productFEE: product.priceUnique * PLATFORM_PRODUCT_FEE,
});

export const parseFringeBenefit = (fringeBenefit) => ({
  ...fringeBenefit,
  priceUnique: fringeBenefit.price,
  currency: fringeBenefit.currency,
  percentExtraCoin: fringeBenefit.cashBackPercentual,
  status: fringeBenefit.productStatus,
  description: fringeBenefit.rules,
  amountInStock: fringeBenefit.amountAvailable,
  downloadable: false,
  fringe: true,
  productVariations: [],
  productFEE: fringeBenefit.price * PLATFORM_PRODUCT_FEE,
});
